import { styled, theme, uiCommon } from '../../lib'

const activeAndHover = {
  backgroundColor: theme.colors.ui_neutral02,
  svg: {
    path: {
      fill: theme.colors.ui_neutral07
    }
  }
}

export const StyledIconButton = styled('button', {
  ...uiCommon.buttonReset,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: theme.sizes.ui_04,
  transition: `all .15s ${uiCommon.transitions.authenticMotion}`,

  svg: {
    path: {
      transition: `all .15s ${uiCommon.transitions.authenticMotion}`,
      fill: theme.colors.ui_neutral04
    }
  },

  '&:hover': {
    ...activeAndHover
  },

  variants: {
    size: {
      small: {
        height: theme.sizes.ui_24,
        width: theme.sizes.ui_24
      },
      medium: {
        height: theme.sizes.ui_32,
        width: theme.sizes.ui_32
      },
      large: {
        height: theme.sizes.ui_40,
        width: theme.sizes.ui_40
      }
    },
    isActive: {
      true: {
        ...activeAndHover,

        '&:hover': {
          svg: {
            path: {
              fill: theme.colors.ui_neutral07
            }
          }
        }
      },
      false: {}
    },
    isDisabled: {
      true: {
        cursor: 'not-allowed',
        opacity: 0.65,
        backgroundColor: theme.colors.ui_neutral02,

        svg: {
          path: {
            fill: theme.colors.ui_neutral04
          }
        },

        '&:hover': {
          svg: {
            path: {
              fill: theme.colors.ui_neutral04
            }
          }
        }
      }
    }
  }
})
